/**
 * API base URL for Savory backend (recipes list, search, etc.).
 * Defaults to localhost for testing. Set REACT_APP_API_URL in .env to override.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "starfish-app-9uavi.ondigitalocean.app";

/**
 * User recipe upload endpoint (process-user-recipe).
 * Not deployed yet – defaults to local server for testing.
 * Set REACT_APP_PROCESS_USER_RECIPE_URL in .env to override (e.g. deployed URL).
 */
export const PROCESS_USER_RECIPE_URL =
  process.env.REACT_APP_PROCESS_USER_RECIPE_URL || "starfish-app-9uavi.ondigitalocean.app/process-user-recipe";

/** GET single recipe by ID. */
export const getRecipeUrl = (id) => `${API_BASE_URL}/recipes/${id}`;

/** PATCH update recipe by ID. */
export const updateRecipeUrl = (id) => `${API_BASE_URL}/recipes/${id}`;

/** Auth endpoints */
export const AUTH_SIGNIN_URL = `${API_BASE_URL}/auth/supabase/signin`;
export const AUTH_VERIFY_URL = `${API_BASE_URL}/auth/supabase/verify`;
export const AUTH_REFRESH_URL = `${API_BASE_URL}/auth/supabase/refresh`;
export const AUTH_SIGNOUT_URL = `${API_BASE_URL}/auth/supabase/signout`;
